<template>
<el-dialog :visible="visible" :title="'Registrar'" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" top="5vh" @open="onOpened">
    <div class="row" v-loading="loading">
        <div class="col-sm-3">
            <el-steps direction="vertical" :active="activeItem" align-center style="height:400px;">
                <el-step title="Paso 1" description="Datos personales"></el-step>
                <el-step title="Paso 2" description="Fotografía"></el-step>
                <el-step title="Paso 3" description="Datos de participación"></el-step>
                <el-step title="Paso 4" description="Documentación"></el-step>
            </el-steps>

        
        </div>
        <div class="col-sm-9 border-left">
            <div class="tab-content py-3">
                <div class="tab-pane fade" :class="{ 'active show': isActive(1) }" id="tab1">
                    <strong>Código</strong>
                    <div class="">{{person.code}}</div>
                    <strong>Participante</strong>
                    <div class="">{{person.personName}}</div>
                    <strong>Documento</strong>
                    <div class="">{{person.docName}} : {{person.docnumber}}</div>
                    <strong>Fecha de nacimiento</strong>
                    <div class="">{{person.birthday}}</div>
                    <strong>Sexo</strong>
                    <div class="">{{person.gender == 'M' ? 'Masculino' : 'Femenino'}}</div>

                </div>
                <div class="tab-pane fade" :class="{ 'active show': isActive(2) }" id="tab2">
                    <div class="d-flex mb-4 justify-content-between">

                        <span v-if="idphoto==null" class="border border-danger text-danger py-1 px-3 rounded h-30px">Fotografia no disponible</span>
                        <span v-else class="border border-success text-success py-1 px-3 rounded h-30px">Fotografiano disponible</span>
                        <el-upload class="upload-demo" :headers="headers" name="file" action="https://fdptkd.perufedup.com/api/photo/upload" accept=".jpg,.png" :data="person" :show-file-list="false" :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess" :on-error="handleAvatarError">
                            <el-button size="small" type="success" plain>{{(idphoto==null) ? 'Clic para subir archivo' : 'Clic para actualizar archivo'}}</el-button>
                        </el-upload>

                    </div>

                    <el-alert title="Foto Tipo CARNET a color en fondo blanco, solo archivos jpg/png con un tamaño menor de 1MB" type="info" :closable="false">
                    </el-alert>
                    <div class="row justify-content-center">
                        <el-image v-if="idphoto!=null" :src="photo.ruta" class="my-4 h-250px">
                            <div slot="placeholder" class="image-slot">
                                cargando<span class="dot">...</span>
                            </div>
                        </el-image>
                    </div>

                </div>
                <div class="tab-pane fade" :class="{ 'active show': isActive(3) }" id="tab2">
                    <strong>Datos de competencia</strong>
                    <div class="" v-if="record_type == 'DE'">
                        <div class="col my-6">
                            <span class="mr-4">Género</span>
                            <el-radio-group v-model="category">
                                <el-radio :label="category">{{(category == 'M') ? 'Masculino' : 'Femenino'}}</el-radio>
                            </el-radio-group>
                        </div>
                        <div class="col my-6">
                            <span class="mr-4">Modalidad</span>
                            <el-select v-model="modalityId" @change="loadDivisiones" filterable placeholder="- Seleccione -" size="medium">
                                <!--<el-option label="Poomsae" value="TKDM01"></el-option>
                                <el-option label="ParaPoomsae" value="TKDM02"></el-option>
                                <el-option label="FreeSTyle" value="TKDM03"></el-option>-->
                                <el-option v-for="item in modalidades" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </div>

                        <div class="col my-6">
                            <span class="mr-4">División</span>
                            <el-select v-model="divisionId" filterable placeholder="- Seleccione -" size="medium" @change="loadSubDiv">
                                <el-option v-for="item in divisiones" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </div>

                        <!--Nivel para kyrougi-->
                        <!--<div class="col my-6" v-if="modalityId == 'TKDM04'">
                            <span class="mr-4">Nivel</span>
                            <el-select v-model="nivelId" filterable placeholder="- Seleccione -" size="medium">
                                <el-option v-for="item in niveles" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </div>-->



                        <div class="col my-6" v-if="isSubDiv">
                            <span class="mr-4">{{(modalityId == 'TKDM01' ? 'Poomsae' : 'Grado')}}</span>

                            <el-select v-model="peso" filterable placeholder="- Seleccione -" size="medium">
                                <el-option v-for="item in subdivisiones" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>

                            <!--<el-select v-model="peso" filterable placeholder="- Seleccione -" size="medium">
                                <el-option v-for="item in poomses" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>-->

                        </div>

                        
                        <div class="col my-6" >
                            <span class="mr-4">Institución educativa</span>
                            <el-input placeholder="" v-model="adicional" size="medium"></el-input>
                        </div>
                        

                    </div>
                    <div class="" v-else>
                        <span class="mr-4">Oficial participa como</span>
                        <el-select v-if="eventInfo.idevent == '80' || eventInfo.idevent == '81'" v-model="oficialId" filterable placeholder="- Seleccione -" size="medium">
                            <el-option :label="'Árbitro nacional'" :value="'70'"></el-option>
                            <el-option :label="'Aspirante árbitro nacional'" :value="'71'"></el-option>
                            <el-option :label="'Árbitro Junior'" :value="'74'"></el-option>
                            <!--
                            <el-option :label="'Coach'" :value="'50'"></el-option>
                            <el-option :label="'Prensa'" :value="'130'"></el-option>
                            <el-option :label="'Personal Médico'" :value="'4'"></el-option>
                            <el-option :label="'Asistente Técnico'" :value="'13'"></el-option>
                            <el-option :label="'Delegado'" :value="'3'"></el-option>
                            <el-option :label="'Jefe de equipo'" :value="'8'"></el-option>
                            -->
                        </el-select>
                        
                        <el-select v-else v-model="oficialId" filterable placeholder="- Seleccione -" size="medium">
                            <!--<el-option :label="'Maestro Instructor'" :value="'72'"></el-option>
                            <el-option :label="'Técnico Instructor'" :value="'73'"></el-option>
                            <el-option :label="'Asistente de Instructor'" :value="'74'"></el-option>-->
                           <!-- <el-option :label="'Personal médico'" :value="'4'"></el-option>
                            <el-option :label="'Coachs'" :value="'50'"></el-option>-->
                            <!--<el-option :label="'IR (Internacional Referee)'" :value="'68'"></el-option>-->
                            <el-option :label="'Coach'" :value="'70'"></el-option>
                            <el-option :label="'Delegado'" :value="'71'"></el-option>
                            <el-option :label="'Trainer'" :value="'72'"></el-option>
                            <el-option :label="'Doctor'" :value="'73'"></el-option>
                            <el-option :label="'Head of Team'" :value="'75'"></el-option>
                            <el-option :label="'Presidente'" :value="'76'"></el-option>
                            <el-option :label="'Physiotherapeutic'" :value="'77'"></el-option>
                            <el-option :label="'Photograph'" :value="'78'"></el-option>
                        </el-select>
                        
                        

                        <span class="mr-4">Número de Registro Kukkiwon</span>
                        <el-input placeholder="" v-model="divisionId" size="medium"></el-input>

                        <div class="col my-6" >
                            <span class="mr-4">Club procedencia</span>
                            <el-input placeholder="" v-model="adicional" size="medium"></el-input>
                        </div>

                        <div class="col my-6" >
                            <span class="mr-4">DAN</span>
                            <el-input placeholder="" v-model="modalityId" size="medium"></el-input>
                        </div>

                        <div class="col my-6" >
                            <span class="mr-4">Celular</span>
                            <el-input placeholder="" v-model="peso" size="medium"></el-input>
                        </div>

                        <div class="col my-6" >
                            <span class="mr-4">Distrito, Ciudad y región, dónde radica.</span>
                            <el-input placeholder="" v-model="specialty" size="medium"></el-input>
                        </div>


                    </div>

                </div>
                <div class="tab-pane fade" :class="{ 'active show': isActive(4) }" id="tab2">
                    <strong>Documentos a subir</strong><br><br>

                    <el-alert title="Archivos permitidos en formato jpg/png, pdf con un tamaño menor de 1MB" type="info" class="mb-4" :closable="false">
                    </el-alert>
                    <div class="d-flex mb-4 justify-content-between">
                        <span class="border border-success text-success py-1 px-3 rounded h-30px w-300px">DNI</span>
                        <el-upload class="upload-demo" :headers="headers" name="file1" action="https://fdptkd.perufedup.com/api/file/upload" accept=".jpg,.png,.pdf" :data="{idacreditation: itemData, alias:'DNI', file: 'file1'}" :show-file-list="false" :before-upload="FilbeforeAvatarUpload" :on-success="FilhandleAvatarSuccess" :on-error="FilhandleAvatarError">
                            <el-button size="small" type="success" plain>subir archivo</el-button>
                        </el-upload>
                    </div>
                    <!--
                    <div class="d-flex mb-4 justify-content-between">
                        <span class="border border-success text-success py-1 px-3 rounded h-30px w-300px">Carta de Exención</span>
                        <el-upload class="upload-demo" :headers="headers" name="file2" action="https://fdptkd.perufedup.com/api/file/upload" accept=".jpg,.png,.pdf" :data="{idacreditation: itemData, alias:'CE', file: 'file2'}" :show-file-list="false" :before-upload="FilbeforeAvatarUpload" :on-success="FilhandleAvatarSuccess" :on-error="FilhandleAvatarError">
                            <el-button size="small" type="success" plain>Subir archivo</el-button>
                        </el-upload>
                    </div>
                    <div class="d-flex mb-4 justify-content-between">
                        <span class="border border-success text-success py-1 px-3 rounded h-30px w-300px"> Declaración Jurada de Bioseguridad</span>
                        <el-upload class="upload-demo" :headers="headers" name="file3" action="https://fdptkd.perufedup.com/api/file/upload" accept=".jpg,.png,.pdf" :data="{idacreditation: itemData, alias:'DBS', file: 'file3'}" :show-file-list="false" :before-upload="FilbeforeAvatarUpload" :on-success="FilhandleAvatarSuccess" :on-error="FilhandleAvatarError">
                            <el-button size="small" type="success" plain>Subir archivo</el-button>
                        </el-upload>
                    </div>
                    -->
                </div>
            </div>
        </div>
    </div>
    <div slot="footer" class="dialog-footer">
        <el-button size="small" class="" @click="onClose">Cancelar</el-button>

        <el-button type="primary" size="small" icon="el-icon-info" class="mb-1" @click="setActive(1)">Siguiente</el-button>

    </div>
</el-dialog>
</template>

<script>
import {
    ADD_BODY_CLASSNAME,
    REMOVE_BODY_CLASSNAME
} from "@/store/htmlclass.module.js";

import code from "@/core/config/error";
import dataJson from "@/data/common";

//services
import photoService from "@/core/services/photo.service"
import sportService from "@/core/services/sport.service"
import JwtService from "@/core/services/jwt.service";
import acrService from "@/core/services/acr.service";

export default {
    props: {
        visible: {
            type: Boolean,
            required: true,
            default: false,
        },
        record_type: {
            type: String,
            required: true,
            default: "",
        },
        personInfo: {
            type: Object,
            required: true,
            default: {}
        }, 
        slug: {
            type: String,
            required: true,
            default: "",
        },
        eventInfo: {
            type: Object,
            required: true,
            default: {},
        }
    },
    data: () => ({
        person: {},
        activeItem: 1,
        menuItem: 1,
        idphoto: null,
        photo: {},
        headers: {
            Authorization: `Bearer ${JwtService.getToken()}`
        },
        nivelId: null,
        category: null,
        modalidades: [],
        niveles: dataJson.niveles,
        divisiones: [],
        modalityId: 'TKDM01',
        divisionId: null,
        peso: null,
        specialty: null,
        adicional: null,
        itemData: {},
        statusSave: false,
        poomses: dataJson.poomsae,
        loading: false,
        oficialId: null,
        isSubDiv: false,
        subdivisiones: []
    }),
    methods: {
        onClose() {
            this.divisionId = null
            this.peso = null
            this.adicional = null
            this.idphoto = null
            this.oficialId = null
            this.photo = {}
            this.$emit("update:visible", false);
        },
        onOpened() {
            console.log(this.personInfo)
            this.activeItem = 1
            this.person = this.personInfo
            this.category = this.personInfo.gender
        },
        isActive(menuItem) {
            return this.activeItem === menuItem
        },
        setActive(menuItem) {
            console.log(menuItem)
            this.activeItem += menuItem

            if (this.activeItem == 2) {
                this.loadPhotos()
            }

            if (this.activeItem == 3) {
                this.loadDivisiones()
            }

            if (this.activeItem == 3 && this.idphoto == null) {

                this.activeItem = 2
                this.$message.error({
                    showClose: true,
                    message: 'Falta subir una fotografia con el formato indicado.'
                })
            }

            if (this.activeItem == 4 && this.record_type == 'DE' && (this.modalityId == null || this.divisionId == null)) {
                this.activeItem = 3
                this.$message.error({
                    showClose: true,
                    message: 'Todos los campos son obligatorios.'
                })
            }

            if (this.activeItem == 4 && this.record_type != 'DE' && this.oficialId == null) {
                this.activeItem = 3
                this.$message.error({
                    showClose: true,
                    message: 'Todos los campos son obligatorios.'
                })
            }

            if (this.activeItem == 4 &&  this.record_type == 'DE' && (this.modalityId != null && this.divisionId != null))
                this.guardarBorrador()

            if (this.activeItem == 4 &&  this.record_type != 'DE' && this.oficialId != null)
                this.guardarBorrador()

            if (this.activeItem > 4) {
                this.activeItem = 4
                this.onClose()
            }
        },
        async loadPhotos() {
            //this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
            this.loading = true
            await photoService.get(this.person).then((res) => {
                if (res.data != null) {
                    this.photo = res.data
                    this.idphoto = this.photo.idphoto
                }
            }).catch((error) => {
                //this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
                this.loading = false
                code.Manager(error.response)
            }).finally(() => {
                this.loading = false
                //this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
            })
        },
        handleAvatarSuccess(res, file) {
            //console.log(res)
            //this.photo.ruta = URL.createObjectURL(file.raw);
            //this.photo.idphoto = res.idphoto;
            //this.currentAcreditation.idphoto = res.idphoto;
            this.$message({
                message: res.message,
                type: 'success'
            })
            this.loadPhotos()
        },
        handleAvatarError(err, file) {
            const e = JSON.parse(err.message);
            this.$alert(e.messages.error, 'Error ' + e.error, {
                type: 'warning'
            });
        },
        beforeAvatarUpload(file) {
            const isIMAGE = (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg');

            if (!isIMAGE) {
                this.$message.error('Formato de archivo no admitido!');
                return false;
            }
            return true;
        },
        FilhandleAvatarSuccess(res, file) {
            this.$message({
                message: res.message,
                type: 'success'
            })
            this.loadPhotos()
        },
        FilhandleAvatarError(err, file) {
            const e = JSON.parse(err.message);
            this.$alert(e.messages.error, 'Error ' + e.error, {
                type: 'warning'
            });
        },
        FilbeforeAvatarUpload(file) {

            const isIMAGE = (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'application/pdf');

            if (!isIMAGE) {
                this.$message.error('Formato de archivo no admitido!');
                return false;
            }
            return true;
        },
        async loadModalidades() {
            this.loading = true
            this.modalityId = null
            await sportService.getModalidades({
                idevent: this.eventInfo.idevent,
                idsport: '13',
                eventSlug: this.slug 
            }).then((res) => {
                this.modalidades = res.data
            }).catch((error) => {
                this.loading = false
                code.Manager(error.response)
            }).finally(() => {
                this.loading = false
            })
        },


        async loadDivisiones() {
            //this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
            this.loading = true
            this.divisionId = null
            this.isSubDiv = false
            this.peso = null
            await sportService.getDivisiones({
                idevent: this.eventInfo.idevent,
                idsport: '13',
                modalityId: this.modalityId,
                person: this.person,
            }).then((res) => {
                this.divisiones = res.data
            }).catch((error) => {
                //this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
                this.loading = false
                code.Manager(error.response)
            }).finally(() => {
                this.loading = false
                //this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
            })

        },

        async getSubDivisiones() {
            this.loading = true
            await sportService.getSubDivisiones({
                idsport: '13',
                idevent: this.eventInfo.idevent,
                modalityId: this.modalityId,
                divisionId: this.divisionId,
                person: this.person,
            }).then((res) => {
                this.subdivisiones = res.data
            }).catch((error) => {
                this.loading = false
                code.Manager(error.response)
            }).finally(() => {
                this.loading = false
            })
        },

        loadSubDiv() {
            this.peso= null
            let ar = this.divisiones.filter(param => param.id === this.divisionId);
            let itemDiv = Object.assign({}, ...ar);
            this.isSubDiv = itemDiv.subdiv
            if(this.isSubDiv) {
                //load subdivisiones
                this.getSubDivisiones()

            }
            console.log(itemDiv)

        },

        async guardarBorrador() {
            this.loading = true
            await acrService.save({
                idevent: this.eventInfo.idevent,
                person: this.person,
                record_type: this.record_type,
                modalityId: this.modalityId,
                divisionId: this.divisionId,
                peso: this.peso,
                idphoto: this.idphoto,
                oficialId: this.oficialId,
                nivelId: this.nivelId,
                adicional: this.adicional,
                specialty: this.specialty 
            }).then((res) => {
                this.statusSave = res.data.status
                if (res.data.status) {
                    this.itemData = res.data.acrd
                    this.activeItem = 4
                    this.$emit("listParticipantes")
                } else {
                    this.activeItem = 3
                    this.$message.error(res.data.message);
                }
                console.log(res.data)
                console.log(this.itemData)
            }).catch((err) => {
                this.activeItem = 3
                this.loading = false
                //this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
                code.Manager(err.response)
            }).finally(() => {
                this.loading = false
                //this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
            })
        }
    },
    created() {
        this.loadModalidades()
    }

}
</script>
